/** Legacy scheduling/leave permission strings (runtime alias expansion + DB migration). */
export const LEGACY_SCHEDULING_MANAGE = 'scheduling:manage';
export const LEGACY_SCHEDULING_TIME_OFF_REQUEST = 'scheduling:time-off-request';
export const LEGACY_SCHEDULING_APPROVE_TIME_OFF = 'scheduling:approve-time-off';

export const LEAVE_PERMISSIONS = {
  READ: 'leave:read',
  REQUEST: 'leave:request',
  APPROVE: 'leave:approve',
  TYPES_MANAGE: 'leave:types:manage',
  ENTITLEMENTS_MANAGE: 'leave:entitlements:manage',
  REQUESTS_MANAGE: 'leave:requests:manage',
} as const;

export const SCHEDULING_GRANULAR_PERMISSIONS = {
  READ: 'scheduling:read',
  SHIFT_TYPES_MANAGE: 'scheduling:shift-types:manage',
  TEMPLATES_MANAGE: 'scheduling:templates:manage',
  ASSIGNMENTS_MANAGE: 'scheduling:assignments:manage',
} as const;

export const DEPRECATED_LEAVE_SCHEDULING_PERMISSIONS = [
  LEGACY_SCHEDULING_MANAGE,
  LEGACY_SCHEDULING_TIME_OFF_REQUEST,
  LEGACY_SCHEDULING_APPROVE_TIME_OFF,
] as const;

export const ALL_LEAVE_PERMISSIONS = Object.values(LEAVE_PERMISSIONS);

export const ALL_SCHEDULING_MANAGE_PERMISSIONS = [
  SCHEDULING_GRANULAR_PERMISSIONS.SHIFT_TYPES_MANAGE,
  SCHEDULING_GRANULAR_PERMISSIONS.TEMPLATES_MANAGE,
  SCHEDULING_GRANULAR_PERMISSIONS.ASSIGNMENTS_MANAGE,
];

const LEGACY_EXPAND_MAP: Record<string, readonly string[]> = {
  [SCHEDULING_GRANULAR_PERMISSIONS.READ]: [LEAVE_PERMISSIONS.READ],
  [LEGACY_SCHEDULING_TIME_OFF_REQUEST]: [
    LEAVE_PERMISSIONS.REQUEST,
    LEAVE_PERMISSIONS.READ,
  ],
  [LEGACY_SCHEDULING_APPROVE_TIME_OFF]: [
    LEAVE_PERMISSIONS.APPROVE,
    LEAVE_PERMISSIONS.READ,
  ],
  [LEGACY_SCHEDULING_MANAGE]: [
    SCHEDULING_GRANULAR_PERMISSIONS.READ,
    ...ALL_SCHEDULING_MANAGE_PERMISSIONS,
    ...ALL_LEAVE_PERMISSIONS,
  ],
};

export const expandLegacyPermissions = (permissions: string[] | undefined): string[] => {
  const set = new Set(permissions ?? []);
  for (const perm of permissions ?? []) {
    const implied = LEGACY_EXPAND_MAP[perm];
    if (implied) {
      for (const next of implied) {
        set.add(next);
      }
    }
  }
  return Array.from(set);
};

export const userHasPermission = (
  permissions: string[] | undefined,
  required: string,
): boolean => expandLegacyPermissions(permissions).includes(required);

export const userHasAnyPermission = (
  permissions: string[] | undefined,
  required: string[],
): boolean => {
  const expanded = expandLegacyPermissions(permissions);
  return required.some((perm) => expanded.includes(perm));
};
